module.exports = __webpack_public_path__ + "img/like.e0553461.gif";